import mitt from 'mitt'
import { AlertType } from './components/common/AlertComponent.vue'

type Events = {
  'alert:show': { type: AlertType; message: string }
  'dialog:show': { title: string; message: string; namespace: string }
}

const eventBus = mitt<Events>()

export default eventBus
